import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@mui/material';
import axios from '../../axiosConfig';

const cardSx = {
  background: '#fff',
  borderRadius: '16px',
  boxShadow: '0 8px 30px rgba(0,0,0,0.08)',
  padding: '32px 28px',
  maxWidth: 480,
  textAlign: 'center',
};

export default function SignupConfirm() {
  const { token } = useParams();
  const [state, setState] = useState('loading');
  const [message, setMessage] = useState('');

  useEffect(() => {
    let cancelled = false;

    (async () => {
      try {
        const res = await axios.post(`/api/public/confirm/${encodeURIComponent(token)}`);
        if (cancelled) return;
        setState('success');
        setMessage(res.data.message || 'Your subscription has been confirmed.');
        if (res.data.redirectUrl) {
          setTimeout(() => {
            window.location.href = res.data.redirectUrl;
          }, 2000);
        }
      } catch (err) {
        if (cancelled) return;
        const status = err.response?.status;
        setMessage(err.response?.data?.error || 'Confirmation failed.');
        setState(status === 410 ? 'expired' : status === 404 ? 'invalid' : 'error');
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [token]);

  let title = 'Confirming subscription…';
  if (state === 'success') title = 'Subscription confirmed';
  else if (state === 'expired') title = 'Link expired';
  else if (state === 'invalid') title = 'Invalid link';
  else if (state === 'error') title = 'Something went wrong';

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#f3f5f8',
        px: 2,
      }}
    >
      <Box sx={cardSx}>
        {state === 'loading' ? (
          <CircularProgress size={32} sx={{ mb: 2 }} />
        ) : null}
        <Typography variant="h5" component="h1" sx={{ fontSize: 20, mb: 1.5 }}>
          {title}
        </Typography>
        <Typography sx={{ color: '#555', lineHeight: 1.5 }}>
          {state === 'loading'
            ? 'Please wait while we confirm your subscription.'
            : message}
        </Typography>
      </Box>
    </Box>
  );
}
